/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { Observable, from, of, take } from 'rxjs';
import { CircuitList } from '../../../../feature/src/lib/models/paneldata-info';
import { DotNetRequestMessageService } from '@mep/web-browser-bridge';
import { PanelCircuitDataReturnCodes } from 'libs/sysque/toolbelt/feature/src/lib/models/panel-circuit-data-return-codes';
import { SelectedPanelDataItem } from 'libs/sysque/toolbelt/feature/src/lib/models/selected-panel-data-item';

@Injectable({
  providedIn: 'root',
})
export class PanelDataService {
  projectList: string[] = [];
  panelList: string[] = [];

  constructor(private messageHandler: DotNetRequestMessageService) {}

  public ApplyPanelData(item: SelectedPanelDataItem): Observable<PanelCircuitDataReturnCodes> {
    return from<Promise<PanelCircuitDataReturnCodes>>(this.messageHandler.sendRequestAsync('ApplyPanelData', [item]));
  }

  public OnCloseWindow(): Observable<boolean> {
    return from<Promise<boolean>>(this.messageHandler.sendRequestAsync('OnCloseWindow'));
  }

  public changeDialogDimensions(height: number): Observable<string> {
    this.messageHandler.sendRequestAsync('ChangeDialogDimensions', [height]);
    return of('OK');
  }

  public validatePanelCircuitData(): Observable<PanelCircuitDataReturnCodes> {
    return from<Promise<PanelCircuitDataReturnCodes>>(this.messageHandler.sendRequestAsync('ValidateSelection'));
  }

  public getProjectData(): Promise<string[]> {
    return this.messageHandler.sendRequestAsync('InitializePanelCircuitData');      
  }

  public getPanelData(projectName: string, initialize: boolean): Promise<string[]> {
    return this.messageHandler.sendRequestAsync('GetPanelData', [projectName, initialize]);
  }

  public getCircuitData(projectName: string, panelName: string): Promise<CircuitList[]> {
    return this.messageHandler.sendRequestAsync('GetCircuitData', [projectName, panelName]);
  }
}
